import Logout from '@/components/Security/logout'
import Unauthorized from '@/components/Security/unauthorized'
import Profile from '@/components/Security/profile'
import AuthPreprod from '@/components/Security/authPreprod'

let SecurityRouter = [{
    path: '/security/profile',
    name: 'Profile',
    component: Profile,
    meta: {
      title: 'Mon profil',
      requiresAuth: true
    }
  },
  {
    path: '/security/logout',
    name: 'Logout',
    component: Logout,
    meta: {
      title: 'Déconnexion',
      hideHeader: true,
      hideFooter: true,
      hideMenu: true
    }
  },
  {
    path: '/security/unauthorized',
    name: 'Unauthorized',
    component: Unauthorized,
    meta: {
      title: 'Accès refusé'
    }
  },
  {
    path: '/security/unauthorized/:message',
    name: 'UnauthorizedWithMessage',
    component: Unauthorized,
    meta: {
      title: 'Accès refusé'
    }
  },
  {
    // PREPROD uniquement : connexion directe par e-mail ou par id, sans Azure.
    // Pas de requiresAuth, sinon le beforeEach du router renverrait vers Azure
    // avant d'avoir pu poser le token. Garde côté back via PREPROD_MOD.
    path: '/auth_preprod/:identifier',
    name: 'AuthPreprod',
    component: AuthPreprod,
    meta: {
      title: 'Connexion preprod',
      hideHeader: true,
      hideFooter: true,
      hideMenu: true
    }
  },
  {
    path: '/security/azure',
    name: 'Azure',
    meta: {
      title: 'Connexion',
      requiresAuth: true
    }
  }
]

export default SecurityRouter



// WEBPACK FOOTER //
// ./src/components/Security/router.js